import React from "react";
import PageHeader from "../../../components/common/PageHeader";
import OrderStatusBlocks from "./OrderStatusBlocks";
import OrderCards from "./OrderCards";
import { useRestaurantConfig } from "../../../utils/restaurantConfig";
import { formatDateInTimezone } from "../../../utils/dateTimeUtils";

const OrderListView = ({
  orders,
  filteredOrders,
  searchTerm,
  setSearchTerm,
  selectedSort,
  displayStatuses,
  handleStatusClick,
  getCountByStatus,
  getStatusColor,
  setPopupOrder,
  setAddress,
  setDriverId,
  setDriverName,
  setDriverMobile,
  setUseNewDriver,
}) => {
  const { timezone } = useRestaurantConfig();
  const todayLabel = formatDateInTimezone(new Date(), timezone, "en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
  <>
    <PageHeader
      showBackButton={true}
      title="Online Orders"
      subtitle={`Manage and track all online delivery orders : ${todayLabel}`}
      action={
        <span className="text-sm text-gray-500 font-medium">
          {orders.length} order{orders.length !== 1 ? "s" : ""}
        </span>
      }
    />

    {/* Status blocks — desktop only */}
    <OrderStatusBlocks
      displayStatuses={displayStatuses}
      handleStatusClick={handleStatusClick}
      selectedSort={selectedSort}
      getCountByStatus={getCountByStatus}
    />

    {/* Status dropdown — mobile only */}
    <div className="md:hidden mb-5 bg-white rounded-xl border border-gray-200 shadow-sm p-4">
      <label className="block font-semibold text-sm text-gray-700 mb-2">
        Statuses:
      </label>
      <select
        value={selectedSort || "all"}
        onChange={(e) => handleStatusClick(e.target.value)}
        className="w-full p-2.5 text-sm border border-gray-300 rounded-lg focus:outline-none focus:border-black bg-gray-50"
      >
        <option value="all">All ({orders.length})</option>
        {displayStatuses
          .filter((s) => s !== "all")
          .map((status) => (
            <option key={status} value={status}>
              {status.charAt(0).toUpperCase() + status.slice(1)} (
              {getCountByStatus(status)})
            </option>
          ))}
      </select>
    </div>

    {/* Search */}
    <div className="mb-5">
      <input
        type="text"
        placeholder="Search orders by ID, Phone, or Status..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="w-full p-3 text-sm rounded-xl border border-gray-200 shadow-sm bg-white focus:outline-none focus:border-black transition-all"
      />
    </div>

    <OrderCards
      filteredOrders={filteredOrders}
      selectedSort={selectedSort}
      setPopupOrder={setPopupOrder}
      setAddress={setAddress}
      setDriverId={setDriverId}
      setDriverName={setDriverName}
      setDriverMobile={setDriverMobile}
      setUseNewDriver={setUseNewDriver}
      getStatusColor={getStatusColor}
    />
  </>
  );
};

export default OrderListView;
